import {ApplicationInsightsService} from "./azure/insights-service/application-insights.service";
import {ErrorHandler, Injectable} from "@angular/core";
import {SeverityLevel} from "../utilities/project-utils";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  constructor(private insightService: ApplicationInsightsService) {
    super();
  }

  override handleError(error: Error) {
    this.insightService.logException(error,
      'ErrorHandlerService',
      'handleError', '13', SeverityLevel.Critical); // Manually log exception
  }
}
